import React, { useEffect, useState } from 'react'
import _debounce from 'lodash/debounce';
import Popup from '../../../ReusableFunctions/Popup';
import Loading from '../../../ReusableFunctions/Loader';
import { getSubscriptionDetails } from '../../../apis/subscription';

const Subscription = ({ dsp }) => {
    const [subscription, setSubscription] = useState(null);

  const getSubscription = async () => {
    try {
      Loading.set(true);
      const res = await getSubscriptionDetails();
      setSubscription(res?.subscription); 
      Loading.set(false);
    } catch (error) {
      Loading.set(false);
      Popup.alert("Error", error, "ERROR");
    }
  };

  useEffect(() => {
    getSubscription();
  }, []);

  if (!subscription) {
    return null;
  }

  const formatDate = (dateStr) => {
    return new Date(dateStr).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const totalLeads = subscription.total_lead || 0;
  const consumedLeads = subscription.limits?.leads?.usage || 0;
  const remainingLeads = subscription.limits?.leads?.limits - consumedLeads;

    return (
        <>
            <div
                className="transaction_history_wrapper"
                style={{ padding: "30px", display: "block" }}
            >
                <div className="transaction_history_wrapper_header" style={{ marginBottom: "20px" }}>
                    <h4>Subscription</h4>
                </div>

                <div style={{ marginBottom: "20px" }} className='flex items-center justify-between'>
                    <div>{!subscription && (
                        <p>No Active Subscription</p>
                    )}
                    {subscription && (
                        <p>Active Subscription</p>
                    )}
                    </div>
                    <div>
                    <button
                        onClick={() => {
                        window.location.href = "/plan-purchase";
                        }}
                        className="inline-flex bg-[#0F5EFF] text-white px-3 py-1 rounded items-center justify-center"
                    >
                        Change Plan
                    </button>
                    </div>
                </div>
                {subscription && (
                <div
                    style={{
                        display: "flex",
                        gap: "20px",
                    }}
                >
                    <div
                        style={{
                            border: "1px solid #d0d7de",
                            borderRadius: "8px",
                            padding: "16px 20px",
                            flex: "1",
                        }}
                    >
                        <div style={{ display: "flex", alignItems: "center", marginBottom: "12px" }}>
                            <span
                                style={{
                                    background: "#0a0f1a",
                                    color: "#fff",
                                    padding: "6px 12px",
                                    borderRadius: "6px",
                                    fontSize: "14px",
                                    fontWeight: "600",
                                    marginRight: "12px",
                                }}
                            >
                                {subscription.plan_name}
                            </span>
                            {/* <span style={{ fontSize: "14px", color: "#6b7280" }}>Renews {formatDate(subscription?.end_date)}</span> */}
                        </div>

                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                            <div>
                                <p style={{ fontSize: "14px", color: "#6b7280" }}>Start Date</p>
                                <p style={{ fontWeight: "600" }}>{formatDate(subscription?.start_date)}</p>
                            </div>
                            <div>
                                <p style={{ fontSize: "14px", color: "#6b7280" }}>Expire Date</p>
                                 <p style={{ fontWeight: "600" }}>{ subscription?.type === 'lifetime' ? 'Lifetime' : formatDate(subscription?.end_date)}</p>
                            </div>
                        </div>
                    </div>
 {subscription?.plan_name !== "Individual Plan" && (<>
                    <div
                        style={{
                            border: "1px solid #d0d7de",
                            borderRadius: "8px",
                            padding: "16px",
                            minWidth: "150px",
                            textAlign: "left",
                        }}
                    >
                        <p style={{ fontSize: "14px", color: "#374151", paddingBottom: "40px"}}>Total Leads</p>
                        <p style={{ fontSize: "20px", fontWeight: "600" }}>{totalLeads}</p>
                    </div>

                    <div
                        style={{
                            border: "1px solid #d0d7de",
                            borderRadius: "8px",
                            padding: "16px",
                            minWidth: "150px",
                            textAlign: "left",
                        }}
                    >
                        <p style={{ fontSize: "14px", color: "#374151",paddingBottom: "40px" }}>Consumed Leads</p>
                        <p style={{ fontSize: "20px", fontWeight: "600" }}>{consumedLeads}</p>
                    </div>

                    <div
                        style={{
                            border: "1px solid #d0d7de",
                            borderRadius: "8px",
                            padding: "16px",
                            minWidth: "150px",
                            textAlign: "left",
                        }}
                    >
                        <p style={{ fontSize: "14px", color: "#374151",paddingBottom: "40px" }}>Remaining Leads</p>
                        <p style={{ fontSize: "20px", fontWeight: "600" }}>{remainingLeads}</p>
                    </div>
                    </>)}
                </div>
                
                )}
            </div>
        </>

    )
}

export default Subscription